import {lory} from 'lory.js';
import du from '../utils/dom-utilities';
import {getMenuLimit} from './anchor';

/**
 * initNavigationSwipe - Init third level menu -
 * Create or destroy a Lory instance
 * @export
 * @function
 * @param  {String} [target=null] - DOM target string
 * @return {Object[]} slider - The Lory slider instance
 */
const initNavigationSwipe = (target = null) => {
    if (!target) {
        return;
    }

    return du.queryAll(target).map((DOMTarget) => {

        const options = {
            enableMouseEvents: true,
            classNameFrame: 'js-navigation-swipe-frame',
            classNameSlideContainer: 'js-navigation-swipe-items',
            infinite: false
        };

        const menu = '.navigation-swipe__items';
        const slider = lory(DOMTarget, options);
        let padding = 40; // Add 40px to menu width

        if (window.innerWidth < (getMenuLimit(menu) + padding)) {
            du.setClass(DOMTarget, 'navigation-swipe--active');
            slider.setup();
        } else {
            du.unsetClass(DOMTarget, 'navigation-swipe--active');
            slider.destroy();
        }

        du.onEvent(window, 'optimized-resize', () => {
            if (window.innerWidth < (getMenuLimit(menu) + padding)) {
                du.setClass(DOMTarget, 'navigation-swipe--active');
                slider.setup();
            } else {
                du.unsetClass(DOMTarget, 'navigation-swipe--active');
                slider.destroy();
            }
        });

        return slider;
    });
};

export default initNavigationSwipe;



// WEBPACK FOOTER //
// ./src/main/js/components/navigationSwipe.js